module.exports = __webpack_public_path__ + "img/Path 16@3x.7101352e.png";